import axiosClient from "../axios-client";
import { getActiveUserDetails, adminInviteStart, adminInviteSuccess, adminInviteFailure, adminInviteDetailsStart, adminInviteDetailsSuccess, adminInviteDetailsFailure, verifyUserEventStart, verifyUserEventSuccess, verifyUserEventFailure } from "../reducers/authReducer";
import { changeLoaderStatus } from "../actions/loaderAction"
import authHeader from "../services/auth-header";
import { toastMessage } from "../toaster/toaster";


// ===============================================================================
// =================================== POST API ==================================
// ===============================================================================

export const loginAdmin = async (dispatch, data) => {
    try {
        changeLoaderStatus(dispatch, true)
        const res = await axiosClient.post(`/auth/login`, data)
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
        return res?.data
    } catch (error) {
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
        throw error
    }
}


export const logoutAdmin = async (dispatch) => {
    try {
        changeLoaderStatus(dispatch, true)
        var token = authHeader();
        await axiosClient.post(`/auth/logout`, { "token": token })
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
    } catch (error) {
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
    }
}


export const forgotPasswordAdmin = async (dispatch, data) => {
    try {
        changeLoaderStatus(dispatch, true)
        await axiosClient.post(`/auth/forgot-password`, data)
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
    } catch (error) {
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
        throw error
    }
}


export const resetPasswordAdmin = async (dispatch, data) => {
    try {
        changeLoaderStatus(dispatch, true)
        const res = await axiosClient.post(`/auth/reset-password`, data)
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
        return res?.data
    } catch (error) {
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
        throw error
    }
}


export const getActiveUser = async (dispatch, token = null) => {
    changeLoaderStatus(dispatch, true);
    if (token === null) {
        token = authHeader();
    } else {
        token = `Bearer ${token}`
    }
    const data = { "token": token };

    try {
        const res = await axiosClient.post(`/auth/active-user`, data);
        dispatch(getActiveUserDetails(res?.data));
        return res?.data;
    } catch (error) {
        toastMessage(error.response.data.error, "error");
        throw error;
    } finally {
        setTimeout(() => {
            changeLoaderStatus(dispatch, false);
        }, 500);
    }
};


export const adminInvitePost = async (dispatch, data) => {
    dispatch(adminInviteStart());
    try {
        const token = authHeader();
        changeLoaderStatus(dispatch, true)
        const res = await axiosClient.post(`/auth/invite`, data, {
            headers: {
                Authorization: token
            }
        })
        dispatch(adminInviteSuccess(res.data));
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
    } catch (error) {
        dispatch(adminInviteFailure(error.response.data));
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
    }
}


export const adminInviteDetailsPost = async (dispatch, data) => {
    dispatch(adminInviteDetailsStart());
    try {
        const token = authHeader();
        changeLoaderStatus(dispatch, true)
        const res = await axiosClient.post(`/auth/invite-details`, data, {
            headers: {
                Authorization: token
            }
        })
        dispatch(adminInviteDetailsSuccess(res.data));
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
    } catch (error) {
        dispatch(adminInviteDetailsFailure(error.response.data));
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
    }
}


export const verifyUser = async (dispatch, data) => {
    dispatch(verifyUserEventStart());
    try {
        changeLoaderStatus(dispatch, true)
        const res = await axiosClient.post(`/auth/verify`, data)
        dispatch(verifyUserEventSuccess(res.data));
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
    } catch (error) {
        dispatch(verifyUserEventFailure(error.response.data));
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
    }
}


// ===============================================================================
// =================================== PUT API ===================================
// ===============================================================================

export const updateProfile = async (dispatch, data) => {
    changeLoaderStatus(dispatch, true)
    await axiosClient.put(`/auth/update-profile`, data).then((res) => {
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
        toastMessage("Profile updated successfully", "success");
    }).catch((error) => {
        setTimeout(() => {
            changeLoaderStatus(dispatch, false)
        }, 500);
        toastMessage("Profile not updated", "error");
        throw error
    })
}